import { render, staticRenderFns } from "./TargetAndReward.vue?vue&type=template&id=3cc7ba5e&scoped=true&"
import script from "./TargetAndReward.vue?vue&type=script&lang=js&"
export * from "./TargetAndReward.vue?vue&type=script&lang=js&"
import style0 from "./TargetAndReward.vue?vue&type=style&index=0&id=3cc7ba5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc7ba5e",
  null
  
)

export default component.exports